let cookieBanner 
function getCookie(e) {
    for (var r = e + "=", a = document.cookie.split(";"), t = 0; t < a.length; t++) {
        for (var n = a[t];
            " " == n.charAt(0);) n = n.substring(1);
            if (-1 != n.indexOf(r)) return n.substring(r.length, n.length)
        }
    return ""
}
function setCookie(cookieName,cookieValue,daysToExpire){
    var date = new Date();
    date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

function easeInOut(e, r, a) {
    return -r / 2 * (Math.cos(Math.PI * clock.elapsedTime / a) - 1) + e
}

function init() {

    cookieBanner = document.getElementById("shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
    }

    container = document.createElement("div"), document.body.appendChild(container), document.getElementById("canvasContainer").appendChild(container), camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 2e3), camera.position.set(0, yStart, 100), scene = new THREE.Scene;
    scene.add(new THREE.AmbientLight(16777215));
    var e, r, a;
    wobbleObjects = new Array, easeObjects = new Array;
    var t = new THREE.TextureLoader;
    t.crossOrigin = "", overlayMaterial = new THREE.MeshBasicMaterial({
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), overlayObject = new THREE.Mesh(new THREE.PlaneGeometry(300, 300, 1, 1), overlayMaterial), overlayObject.position.set(0, 90, 0), scene.add(overlayObject), a = myTextureArray[0], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(300, 300, 1, 1), r), e.position.set(0, -50, -200), scene.add(e), wobbleObjects.push(e), a = myTextureArray[1], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(200, 200, 1, 1), r), e.position.set(0, -40, -400), scene.add(e), wobbleObjects.push(e), e = new THREE.Mesh(new THREE.PlaneGeometry(200, 200, 1, 1), r), e.position.set(-200, 0, -550), scene.add(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-200, 200, 1, 1), r), e.position.set(200, 0, -550), scene.add(e), a = myTextureArray[2], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(1e3, 500, 1, 1), r), e.position.set(0, -150, -150), scene.add(e), wobbleObjects.push(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-1e3, 500, 1, 1), r), e.position.set(0, -150, -350), scene.add(e), wobbleObjects.push(e), a = myTextureArray[3], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(1e3, 500, 1, 1), r), e.position.set(0, -150, -250), scene.add(e), wobbleObjects.push(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-1e3, 500, 1, 1), r), e.position.set(0, -150, -450), scene.add(e), wobbleObjects.push(e), a = myTextureArray[11];
    var n = myTextureArray[12];
    r = new THREE.MeshLambertMaterial({
        map: a,
        alphaMap: n,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(1400, 700, 1, 1), r), e.position.set(0, -300, -599), scene.add(e), wobbleObjects.push(e), a = myTextureArray[5], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(150, 150, 1, 1), r), e.position.set(0, 50, -800), scene.add(e), a = myTextureArray[6], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(100, 400, 1, 1), r), e.position.set(300, -50, -900), scene.add(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-100, 400, 1, 1), r), e.position.set(-300, -50, -900), scene.add(e), a = myTextureArray[7], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(800, 200, 1, 1), r), e.position.set(-200, 150, -100), scene.add(e), e = new THREE.Mesh(new THREE.PlaneGeometry(800, 200, 1, 1), r), e.position.set(-200, 150, -1e3), scene.add(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-800, 200, 1, 1), r), e.position.set(200, 200, -500), scene.add(e), e = new THREE.Mesh(new THREE.PlaneGeometry(-800, 200, 1, 1), r), e.position.set(200, 250, -1e3), scene.add(e), a = myTextureArray[8], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(800, 200, 1, 1), r), e.position.set(-100, 250, -200), scene.add(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-600, 150, 1, 1), r), e.position.set(-200, 200, -700), scene.add(e), a = myTextureArray[9], r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(800, 200, 1, 1), r), e.position.set(200, 250, -400), scene.add(e), r = new THREE.MeshLambertMaterial({
        map: a,
        transparent: !0,
        color: 16777215,
        side: THREE.BackSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(-600, 150, 1, 1), r), e.position.set(-200, 150, -300), scene.add(e), r = new THREE.MeshBasicMaterial({
        transparent: !1,
        color: 15519390,
        side: THREE.FrontSide
    }), e = new THREE.Mesh(new THREE.PlaneGeometry(5e3, 5e3, 1, 1), r), e.position.set(0, 0, -1500), scene.add(e), renderer = new THREE.WebGLRenderer({
        antialias: !0,
        alpha: !0
    }), renderer.setPixelRatio(window.devicePixelRatio), renderer.setSize(document.body.clientWidth, window.innerHeight), container.appendChild(renderer.domElement), window.addEventListener("resize", onWindowResize, !1);

    document.getElementById("canvasContainer").addEventListener('click', onScrollToEndVideo);

    window.addEventListener('scroll', onScrollToEndVideo);

    for (var o = document.getElementsByClassName("absoluteImgPosition"), s = 0; s < o.length; s++) o[s].className += " startInvisible "

    var body = document.body;
    body.classList.remove("IntroLoad");
}

function onScrollToEndVideo(ev){
    window.removeEventListener('scroll', onScrollToEndVideo);

    endScene();
}

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight, camera.updateProjectionMatrix(), renderer.setSize(document.body.clientWidth, window.innerHeight), render()
}

function animate() {
    running && (requestAnimationFrame(animate), render())
}

function render() {
    var e = clock.getDelta();
    camera.position.z >= cameraEnd && 1 == running ? (overlayMaterial.opacity -= .01, camMaxSpeed > camSpeed && (camSpeed += camAcceleration), camera.position.z < slowStart && (camSpeed -= 1.5), camera.position.z -= camSpeed * e) : endScene(), wobbleObjects[0].position.y = easeInOut(-50, 150, 5), wobbleObjects[1].position.y = easeInOut(75, -75, 7), wobbleObjects[2].position.y = easeInOut(-50, -100, 4), wobbleObjects[3].position.y = easeInOut(-25, -100, 6), wobbleObjects[4].position.y = easeInOut(-175, 50, 5), wobbleObjects[5].position.y = easeInOut(-175, 75, 6), wobbleObjects[6].position.y = easeInOut(-100, -200, 9), renderer.render(scene, camera)
}

function endScene() {
    if (cookieBanner) {
        cookieBanner.style.display = "block";
    }

    var body = document.body;
    body.classList.remove("IntroLoad");

    window.removeEventListener('scroll', onScrollToEndVideo);

    gsap.fromTo("#canvasContainer", {opacity: 1}, {
        opacity: 0, height: 0, duration: 1, ease: 'power1.out', onComplete: function () {
            document.getElementById("canvasContainer").remove();
            body.classList.add("IntroEnd");
        }
    });

//    gsap.to("body", {
//        paddingTop: 160, duration: 1, ease: 'power1.out'
//    });

    camAcceleration = 0, camSpeed = 0, camMaxSpeed = 0, running = !1
}
var camera, scene, renderer, loader, clock = new THREE.Clock,
    timePassed = 0,
    yStart = 35,
    camSpeed = 0,
    camAcceleration = 1,
    camMaxSpeed = 100,
    cameraEnd = -600,
    slowStart = -450,
    running = !0,
    wobbleObjects, easeObjects, overlayObject, overlayMaterial, elem = document.getElementById("myBar"),
    textureManager = new THREE.LoadingManager;
textureManager.onProgress = function(e, r, a) {
    if (elem){
        elem.style.width = r / a * 100 + "%"
    }
}, textureManager.onLoad = function() {
    if (elem){
        elem.style.display = "none"
    }

    {(!(getCookie('firstLoad') == '')) ? endScene() : ( setCookie('firstLoad', 1, 14), init(), animate());}
};
var textureLoader = new THREE.TextureLoader(textureManager),
    myTextureArray = [],
    myTexture = new THREE.Texture;
THREE.ImageUtils.crossOrigin = "", THREE.TextureLoader.prototype.crossOrigin = "", myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/gate1.png?v=82572458734503431881732694076")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/gate2.png?v=152805386405397766001732694078")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/floorsand.png?v=168022545876819590511732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/floorblue.png?v=107713506797476845461732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/floorwaves.png?v=70253842056260943431732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/rearobj.png?v=138085281177325455191732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/frotlix.png?v=173082401252066591061732694080")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/cloud4.png?v=54703895417404987281732694078")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/cloud5.png?v=136273263982538190981732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/cloud6.png?v=128941114615099328471732694077")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/bg.jpg?v=142807798274449583451732694079")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/FloorWavesBlur.jpg?v=143892781134812229161732694076")), myTextureArray.push(textureLoader.load("//griegst.com/cdn/shop/t/30/assets/FloorWavesTransparency.jpg?v=148385399456708230081732694080"));